import * as http from "http";
import * as https from "https";

import { Express } from "express";

export abstract class SingletonController {
    public async beforeStart(): Promise<void> {
        // virtual
    }

    public async setupMiddleware(_expressApplication: Express): Promise<void> {
        // virtual
    }

    public async afterStop(): Promise<void> {
        // virtual
    }

    public async afterStart(_httpServer: http.Server, _httpsServer?: https.Server): Promise<void> {
        // virtual
    }
}
